import { render, staticRenderFns } from "./HsabImportedClaimColumnHeader.vue?vue&type=template&id=aebb6f0e&scoped=true"
import script from "./HsabImportedClaimColumnHeader.vue?vue&type=script&lang=ts"
export * from "./HsabImportedClaimColumnHeader.vue?vue&type=script&lang=ts"
import style0 from "./HsabImportedClaimColumnHeader.vue?vue&type=style&index=0&id=aebb6f0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aebb6f0e",
  null
  
)

export default component.exports